import React from "react";

import { Navbar } from "../../../components";
import { Kfc } from "./Kfc";

const KfcProject = () => {
  return (
    <div className="app">
      <Navbar />
      <Kfc />
    </div>
  );
};

export default KfcProject;
